import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import React, { useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { httpClient } from 'helpers/HttpClient.js';
import { FormatDateToDb } from 'helpers/FormatData.js';
const URI = ApiEndpoint + 'operations/';
const ReOpenQueja = ({
  idQueja,
  closeModal,
  setErrorMesagge,
  setShowErrorMessage,
  setIsError
}) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [date, setDate] = useState(null);

  const {
    register,
    handleSubmit,

    formState: { errors }
  } = useForm();

  const onSubmit = data => {
    console.log(FormatDateToDb(date));
    httpClient(
      'POST',
      URI + 'reopen/',
      {
        in_recepcionqueja: idQueja,
        date: FormatDateToDb(date),
        ispresecencial: data.esPresencial,
        in_notas: data.notas,
        minute: date.getMinutes(),
        hour: date.getHours()
      },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          closeModal();
          setIsError(false);
          setErrorMesagge('Seguimiento creado con exito');
          setShowErrorMessage(true);
        } else {
          setIsError(true);
          setErrorMesagge('Ha ocurrido un error al registrar el seguimiento');
          setShowErrorMessage(true);
        }
      })
      .catch(function (error) {
        console.log(error);
        setIsError(true);
        setErrorMesagge('Ha ocurrido un error al registrar el seguimiento');
        setShowErrorMessage(true);
      })
      .finally(() => {});
  };
  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Fecha Proxima Audiencia</Form.Label>
                <DatePicker
                  popperPlacement="bottom-start"
                  selected={date}
                  onChange={date => setDate(date)}
                  className="form-control"
                  placeholderText="DD-MM-YYYY HH:mm"
                  timeIntervals={5}
                  dateFormat="dd-MM-yyyy HH:mm"
                  showTimeSelect
                  fixedHeight
                />
                <Form.Control.Feedback type="invalid">
                  {errors.estado?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Notas</Form.Label>
                <FormControl
                  {...register('notas', { required: true })}
                  type="text"
                  defaultValue={''}
                  isInvalid={!!errors.audiencia}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.audiencia?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Es Presencial</Form.Label>
                <Form.Check
                  {...register('esPresencial')}
                  defaultChecked={false}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.esPresencial?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button type="submit" color="primary" size="sm">
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};
ReOpenQueja.propTypes = {
  idQueja: PropTypes.string.isRequired,
  closeModal: PropTypes.func,
  setErrorMesagge: PropTypes.func,
  setShowErrorMessage: PropTypes.func,
  setIsError: PropTypes.func
};

export default ReOpenQueja;
